export default __webpack_public_path__ + "static/media/996.6374820c.svg";